import { useState, useRef, useEffect, forwardRef, useImperativeHandle } from 'react';
import { default_info, default_add_memo_info } from "./data/default_data";
import strFunc from '@/lib/lyg/string';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import WriteArea from "./write_area";
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import ModifyClassOfStuOnePopup from "@/pages/comp/basic/student/popup/modify_class_of_stu_one";
import StuEndPopup from "@/pages/comp/basic/student/popup/stu_end_popup";
import getXcolumnJson from "./xcolumn/list";
import DateFunc from '@/lib/lyg/date_func';
import LoadingComponent from "@/pcomponents/common/content/loading";

const WritePage = forwardRef((props: any, ref) => {
  let myProps = {
    select_mcomp_data: {
      mcomp_seq: "",
      api_key: "",
      api_user_seq: "",
    },
    info_arr: [],
    select_idx: -1,
    close_write: () => { },
    close_btn_name: "뒤로",
    is_view_close_btn: true,
    is_view_write_btn: true,
    list: (inData: any) => { },
    refresh_data: (inData: any) => { },
    is_view_mode: true,
    set_is_view_mode: (inData: any) => { },
    is_update: false,
    default_write_info: {},
    counsel_s_select_date: "",
    month_prescribe_s_subject: "",
    is_view_stu_info: true,
    is_view_parent: true,
    is_view_supply: true,
    is_view_basic: true,
    tab_id: "discover_map",
    is_first_tab_scroll: false,
    ...props
  };

  let select_mcomp_data = myProps.select_mcomp_data;
  const [info_arr, set_info_arr] = useState(myProps.info_arr);
  const xColumnArr = getXcolumnJson();
  let init_default_info: any = {
    ...default_info,
    ...myProps.default_write_info,
    "a_join_date": DateFunc.get_date_format(new Date(), "Y-m-d"),
    "a_join_counsel_date": DateFunc.get_date_format(new Date(), "Y-m-d"),
    "class_arr": [],
  };
  const [info, set_info] = useState(init_default_info);
  const [add_memo_info, set_add_memo_info] = useState(default_add_memo_info);
  const [parentArr, setParentArr] = useState<any>([{
    "a_seq": "",
    "a_user_phone": "",
    "a_user_id": "",
    "a_user_pw": "",
    "a_relation": "모",
    "a_order": "0",
    "a_is_attend_sms": "1",
    "a_is_attend_push": "1",
    "a_is_attend_katalk": "1",
  }]);
  const [select_idx, set_select_idx] = useState(myProps.select_idx);
  const [is_view_mode, set_is_view_mode] = useState(myProps.is_view_mode);
  const [is_exist_modify, set_is_exist_modify] = useState(false);
  const [refresh, set_refresh] = useState(false);
  const [loading_data, set_loading_data] = useState({
    is_display: false,
    text: "저장중..",
  });
  const WriteAreaRef = useRef<any>(null);

  useEffect(() => {
    if (myProps.is_update) {
      get_user_info_by_ajax({});
    } else {
      get_last_user_id_num();
    }
  }, [select_idx, select_mcomp_data.mcomp_seq]);

  const setInitData = (inData: any) => {
    let opt_obj = {
      "info_arr": [],
      "select_idx": -1,
      "is_view_mode": true,
      "counsel_s_select_date": "",
      ...inData
    };
    set_info_arr(opt_obj.info_arr);
    set_select_idx(opt_obj.select_idx);
    set_is_view_mode(opt_obj.is_view_mode);
    if (myProps.is_update) {
      get_user_info_by_ajax({
        info_arr: opt_obj.info_arr,
        select_idx: opt_obj.select_idx,
        counsel_s_select_date: opt_obj.counsel_s_select_date
      });
    }
  };

  useImperativeHandle(ref, () => ({
    // 부모 컴포넌트에서 사용할 함수를 선언
    setInitData, get_is_exist_modify, go_write_user_data,
    get_is_view_mode, set_is_view_mode
  }));

  const [popupData, setPopupData] = useState({
    isOpen: false,
    sort: "modify_class",
    stu_seq: "",
    title: "팝업",
    width: "800px",
    height: "85%",
  });

  const get_is_exist_modify = () => { return is_exist_modify; };
  const get_is_view_mode = () => { return is_view_mode; };

  const get_user_info_by_ajax = (inData: any) => {
    let opt_obj = {
      info_arr: info_arr,
      select_idx: select_idx,
      counsel_s_select_date: "",
      ...inData,
    };
    let row_info_arr = opt_obj["info_arr"];
    let row_select_idx = opt_obj["select_idx"];
    if (strFunc.is_empty(row_info_arr[row_select_idx])) {
      alert("선택 회원 정보가 없습니다.");
      myProps.close_write();
      return false;
    }
    let select_user_seq = row_info_arr[row_select_idx]["a_seq"];
    if (strFunc.is_empty(select_user_seq)) {
      alert("회원키가 올바르지 않습니다.");
      myProps.close_write();
      return false;
    }
    let user_info_list_opt: any = {
      "s_user_seq": [select_user_seq],
      s_addon_class_user: "1",
      s_addon_class_user_is_addon_supply_data:"1",
      s_addon_class_user_supply_year:DateFunc.get_date_format(new Date(), "Y"),
      s_addon_class_user_supply_month:DateFunc.get_date_format(new Date(), "m"),
      s_addon_link_user: "1",
      s_addon_profile: "1",
      s_addon_counsel_file: "1",
      s_addon_counsel_data_file: "1",
      s_addon_stu_subject:"1",
      s_addon_invite_code: "1",
      s_addon_comp_link: "1",
      s_addon_recent_counsel: "1",
      s_addon_add_memo: "1",
      s_addon_lecture_time: "1",
      s_addon_daily_report_last: "1",
      s_addon_mprescribe_last: "1",
      s_addon_daily_prescribe_last: "1",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    if (!strFunc.is_empty(select_mcomp_data.api_key)
      && !strFunc.is_empty(select_mcomp_data.api_user_seq)) {
      user_info_list_opt["api_key"] = select_mcomp_data.api_key;
      user_info_list_opt["api_user_seq"] = select_mcomp_data.api_user_seq;
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list', user_info_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            set_is_exist_modify(false);
            let row_user_info = response.data["data"]["info_arr"][0];
            set_info(row_user_info);
            set_add_memo_info({
              ...default_add_memo_info,
              ...(row_user_info.add_memo_info ? row_user_info.add_memo_info : {})
            });
            if (row_user_info.link_user_arr) {
              setParentArrByLinkArr(row_user_info.link_user_arr);
            } else {
              setParentArrByLinkArr([]);
            }
            if (WriteAreaRef.current) {
              WriteAreaRef.current.setInitData({
                info: row_user_info,
                counsel_s_select_date: opt_obj.counsel_s_select_date
              });
            }
          } else {
            alert("회원정보가 없습니다.");
            myProps.close_write();
          }
        } else {

        }
      });
  };
  const get_last_user_id_num = () => {
    let form_json_data:any={
      "pre_fix":"s",
    };
    if (!strFunc.is_empty(select_mcomp_data.api_key)
      && !strFunc.is_empty(select_mcomp_data.api_user_seq)) {
        form_json_data["api_key"] = select_mcomp_data.api_key;
        form_json_data["api_user_seq"] = select_mcomp_data.api_user_seq;
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/get_last_user_id_num', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          let last_user_id_num=response.data["data"]["last_user_id_num"];
          set_info({
            ...info,
            "a_user_id": last_user_id_num,
          });
        } else {

        }
      });
  };

  const setParentArrByLinkArr = (link_user_arr: any) => {
    let tmpParentArr = [];
    for (let i = 0; i < link_user_arr.length; i++) {
      let link_info = link_user_arr[i];
      if (link_info["par_info"] && link_info["stu_info"]) {
        tmpParentArr.push({
          ...link_info,
          "a_seq": link_info["par_info"]["a_seq"],
          "a_user_phone": strFunc.autoHypenPhone(link_info["par_info"]["a_user_phone"]),
          "a_user_id": link_info["par_info"]["a_user_id"],
          "a_user_pw": "",
          "par_info":null,
          "stu_info":null,
        });
      }
    }
    
    setParentArr(tmpParentArr);
  };

  const go_write_user_data = () => {
    if (myProps.is_update) {
      if (strFunc.is_empty(info.a_user_id)) {
        alert("아이디 입력이 필요합니다.");
        return false;
      }
    }
    if (!myProps.is_update) {
      if (info.a_user_pw == "") {
        alert("암호 입력이 필요합니다.");
        return false;
      }
    }
    if (info.a_user_name == "") {
      alert("이름 입력이 필요합니다.");
      return false;
    }
    if (info.a_school_name == "") {
      alert("학교 입력이 필요합니다.");
      return false;
    }
    if (info.a_stu_grade == "") {
      alert("학년 입력이 필요합니다.");
      return false;
    }

    let tmp_par_arr = getExistParentArr();
    if(!myProps.is_update){
      //처음 등록 시 보호자 입력 필요.
      if(tmp_par_arr.length==0){
        alert("보호자 정보가 입력되지 않았습니다. 보호자 정보를 입력해주세요.");
        return false;
      }
      for(let i=0;i<tmp_par_arr.length;i++){
        if(tmp_par_arr[i]["a_user_phone"].length<13){
          alert("보호자 휴대폰 번호를 올바르게 입력해주세요."+tmp_par_arr[i]["a_user_phone"]);
          return false;
        }
      }
    }
    let write_stu_info = { ...info };
    write_stu_info.write_par_arr = tmp_par_arr;
    write_stu_info.write_add_memo = { ...add_memo_info };

    let user_write_form_json: any = {
      "data_arr": [write_stu_info],
      "is_update": "1",
      "is_stu_subject": "1",
      "is_write_parent": "1",
      "is_write_add_memo": "1",
    };
    
    if (myProps.is_update == false) {
      user_write_form_json["is_update"] = "";
      user_write_form_json["is_default_val"] = "1";
      user_write_form_json["is_add_class_arr"] = "1";
      //user_write_form_json["is_add_counsel_todo"] = "1";
    }
    if (!strFunc.is_empty(select_mcomp_data.api_key)
      && !strFunc.is_empty(select_mcomp_data.api_user_seq)) {
      user_write_form_json["api_key"] = select_mcomp_data.api_key;
      user_write_form_json["api_user_seq"] = select_mcomp_data.api_user_seq;
    }
    set_loading_data({
      is_display: true,
      text: "저장중..",
    });
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/write_student', user_write_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          let row_user_info = response.data["data"][0];
          set_is_exist_modify(false);
          go_finish_write_complete();
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const go_finish_write_complete = () => {
    set_loading_data({
      is_display: true,
      text: "저장되었습니다.",
    });
    setTimeout(() => {
      set_loading_data({
        is_display: false,
        text: "저장중..",
      });
    }, 1000);

    if (myProps.is_update) {
      if (WriteAreaRef.current) {
        WriteAreaRef.current.go_write_tab_area();
      }
    }

    setTimeout(() => {
      set_is_view_mode(true);
      myProps.set_is_view_mode(true);
      myProps.refresh_data({});
      myProps.list({});
      if (myProps.is_update) {
        get_user_info_by_ajax({});
      } else {
        myProps.close_write();
      }
    }, 1000);
  };

  const getExistParentArr = () => {
    let resultParArr = [];
    for (let i = 0; i < parentArr.length; i++) {
      if (parentArr[i]["a_user_phone"] != "") {
        resultParArr.push(parentArr[i]);
      }
    }
    return resultParArr;
  };

  const openModifyClassPopup = () => {
    let pop_title = "클래스관리";

    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "modify_class",
      title: pop_title,
      stu_seq: info.a_seq
    });
  };
  const openStuEndPopup = (inData:any) => {
    let opt_obj={
      ...inData
    };
    let pop_title = "학생 휴/퇴원";

    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "stu_end",
      title: pop_title,
    });
  };

  const modifyClassOfStuPopupCallback = (inData: any) => {
    let opt_obj = {
      class_arr: [],
      ...inData,
    };

    set_info({
      ...info,
      class_arr: [...opt_obj.class_arr],
    });
  };

  return (
    <div>
      <WriteArea
        ref={WriteAreaRef}
        select_mcomp_data={{ ...select_mcomp_data }}
        info={info}
        set_info={(inData: any) => {
          set_info(inData);
          set_refresh(!refresh);
          set_is_exist_modify(true);
        }}
        add_memo_info={add_memo_info}
        set_add_memo_info={(inData: any) => {
          set_add_memo_info(inData);
          set_is_exist_modify(true);
        }}
        parentArr={parentArr}
        setParentArr={(inData: any) => {
          setParentArr(inData);
          set_is_exist_modify(true);
        }}
        refresh_data={() => {
          get_user_info_by_ajax({});
          myProps.refresh_data({});
          myProps.list({});
        }}
        par_list={() => {
          myProps.list({});
        }}
        openModifyClassPopup={openModifyClassPopup}
        openStuEndPopup={openStuEndPopup}
        is_update={myProps.is_update}
        xColumnArr={xColumnArr}
        is_view_close_btn={myProps.is_view_close_btn}
        close_btn_name={myProps.close_btn_name}
        is_view_write_btn={myProps.is_view_write_btn}
        close_write={myProps.close_write}
        go_write_user_data={go_write_user_data}
        is_view_stu_info={myProps.is_view_stu_info}
        is_view_parent={myProps.is_view_parent}
        is_view_supply={myProps.is_view_supply}
        is_view_basic={myProps.is_view_basic}
        is_view_mode={is_view_mode}
        set_is_view_mode={set_is_view_mode}
        is_exist_modify={is_exist_modify}
        set_is_exist_modify={set_is_exist_modify}
        counsel_s_select_date={myProps.counsel_s_select_date}
        month_prescribe_s_subject={myProps.month_prescribe_s_subject}
        tab_id={myProps.tab_id}
        is_first_tab_scroll={myProps.is_first_tab_scroll}
      ></WriteArea>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} >
          {popupData.sort === "modify_class" &&
            <ModifyClassOfStuOnePopup
              select_mcomp_data={{ ...select_mcomp_data }}
              stu_info={info}
              class_arr={info.class_arr}
              callback={modifyClassOfStuPopupCallback}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></ModifyClassOfStuOnePopup>
          }
          {popupData.sort === "stu_end" &&
            <StuEndPopup
              stu_info_arr={[info]}
              callback={() => {
                get_user_info_by_ajax({});
                myProps.refresh_data({});
                myProps.list({});
              }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></StuEndPopup>
          }
        </LayerPopup>
      }
      <LoadingComponent
        is_display={loading_data.is_display}
        text={loading_data.text}
      ></LoadingComponent>
    </div>
  );
});
export default WritePage;